module.exports = __webpack_public_path__ + "static/media/progress_versand.93b239bd.svg";